import { xmlToJson } from './common';
import { BASE_URL } from './constants';

export const getConfig = () => {
  return fetch(`${BASE_URL}/configWMK.json`, {
    headers: {
      'Cache-Control': 'no-cache',
    },
  }).then((res) => {
    if (res.ok) {
      return res.json();
    }
    return Promise.reject(
      new Error('Something went wrong. Please try again later'),
    );
  });
};

export const getPrimaryImages = () => {
  return fetch(`${BASE_URL}?list-type=2&prefix=primary_slider/`)
    .then((res) => {
      if (res.ok) {
        return res.text();
      }
      return Promise.reject(
        new Error('Something went wrong. Please try again later'),
      );
    })
    .then((response) => {
      const res = xmlToJson(response);
      return res?.ListBucketResult?.Contents;
    });
};

export const submitContactForm = async (data: any) => {
  const res = await fetch('https://api.web3forms.com/submit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(data, null, 2),
  });

  return res;
};

export const getProject = (projectId: string) => {
  return fetch(`${BASE_URL}?list-type=2&prefix=portfolio/${projectId}/`)
    .then((res) => {
      if (res.ok) {
        return res.text();
      }
      return Promise.reject(
        new Error('Something went wrong. Please try again later'),
      );
    })
    .then((response) => {
      const res = xmlToJson(response);
      return res?.ListBucketResult?.Contents;
    });
};
